var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.30356 0.238474C-0.109593 0.649641 -0.106427 0.689132 0.346335 1.13979L6.81389 7.75499C7.14272 8.08224 7.84353 8.08139 8.17236 7.75413L14.3838 1.4461C14.797 1.03493 15.2499 0.814797 14.8368 0.40363C14.4236 -0.00753676 14.0804 -0.00753681 13.6673 0.40363L7.55442 6.47882L1.44157 0.395238C1.03685 -0.00753753 0.708282 -0.172692 0.30356 0.238474Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDown);
export default __webpack_public_path__ + "static/media/icon-down.b4cb693dc75363747b2bece996a7aad9.svg";
export { ForwardRef as ReactComponent };